import { ApolloClient, InMemoryCache, split } from '@apollo/client';
// import { ApolloClient, HttpLink, InMemoryCache, split, ApolloProvider, gql, from  } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';

// import fetch from "isomorphic-fetch";
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
// import { onError } from "@apollo/client/link/error";

import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';

// HTTP and Subscriptions setup
// HTTP connection to the API
const uploadLink = createUploadLink({
  uri: process.env.GATSBY_GRAPHQL_URL || 'http://localhost:8002/graphql',
  credentials: 'include',
});

// WebSocket connection to the API
const wsLink = new GraphQLWsLink(
  createClient({
    url: process.env.GATSBY_WS_URL || 'ws://localhost:8002/graphql',
  }),
);

// Split links: send data to each link depending on operation type
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  uploadLink,
);

// Apollo Client setup
export const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});
